
import { GET_TESTIMONIALS} from '../constants/testimonial';
import { SHOW_LOADING, HIDE_LOADING } from '../constants/commons';

export const getTestimonials = (testimonials) => {
    return {
        type: GET_TESTIMONIALS,
        payload: testimonials
    }
}

export const showLoading = () => {
    return {
        type: SHOW_LOADING
    }
}

export const hideLoading = () => {
    return {
        type: HIDE_LOADING
    }
}